import { AiOutlineMenuFold, AiOutlineClose } from "react-icons/ai";
import { Link } from "react-router-dom";
import "../Css/home.css";
import { useState } from "react";
export default function Navbar() {
  const [toggle, setToggle] = useState(true);
  function toggleHandler() {
    setToggle(!toggle);
  }
  function hidefun(){
    setToggle(true)
  }
  return (
    <div className="navbar">
      <nav>
        <div className="logo">
          <h1>
            <Link to="/" onClick={hidefun}>ABU AZHAR</Link>
          </h1>
        </div>
        <div className="menu-toggle" onClick={toggleHandler}>
          {toggle === true ? <AiOutlineMenuFold /> : <AiOutlineClose />}
        </div>
      </nav>
      <div className={toggle === true ? "toggle" : "list-items"}>
        <ul className={toggle ===false ? "new-list": "old-list"}>
          <li>
            <Link to="/" onClick={hidefun}>HOME</Link>
          </li>
          <li>
            <Link to="/about" onClick={hidefun}>ABOUT</Link>
          </li>
          <li>
            <Link to="/resume" onClick={hidefun}>RESUME</Link>
          </li>
          <li>
            <Link to="/project" onClick={hidefun}>PROJECTS</Link>
          </li>
          <li>
            <Link to="/contact" onClick={hidefun}>CONTACT</Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
